<h2 class="mt-3">{{ sections.detailsTitle }}</h2>
<div *ngIf="sections.detailsBody" class="rbrd mb-30">
  <p [innerHTML]="sections.detailsBody | mdToHtml"></p>
</div>
